export default __webpack_public_path__ + "static/media/FR.4e239992.png";